import { useEffect, useState } from "react";
import {
  loadTimePreferences,
  TIME_PREFERENCES_EVENT,
  TIME_PREFERENCES_STORAGE_KEY,
} from "../utils/timePreferences";

const useTimePreferences = () => {
  const [preferences, setPreferences] = useState(loadTimePreferences);

  useEffect(() => {
    const updatePreferences = (event) =>
      setPreferences(event.detail || loadTimePreferences());
    const syncAcrossTabs = (event) => {
      if (event.key === TIME_PREFERENCES_STORAGE_KEY) {
        setPreferences(loadTimePreferences());
      }
    };

    window.addEventListener(TIME_PREFERENCES_EVENT, updatePreferences);
    window.addEventListener("storage", syncAcrossTabs);
    return () => {
      window.removeEventListener(TIME_PREFERENCES_EVENT, updatePreferences);
      window.removeEventListener("storage", syncAcrossTabs);
    };
  }, []);

  return preferences;
};

export default useTimePreferences;
